import { render, staticRenderFns } from "./ContactSearch.vue?vue&type=template&id=0545f73a&scoped=true&"
import script from "./ContactSearch.vue?vue&type=script&lang=js&"
export * from "./ContactSearch.vue?vue&type=script&lang=js&"
import style0 from "./ContactSearch.vue?vue&type=style&index=0&id=0545f73a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0545f73a",
  null
  
)

export default component.exports